import {filter, map} from 'lodash';

import MultiSelectFilter, {
  multiselectOrFilter,
} from 'components/Table/Filter/MultiSelect';
import TextFilter from 'components/Table/Filter/Text';
import VirtualizedTable from 'components/Table/Virtualized';
import {flexColumnStyle} from 'components/Table/columnHelpers';
import Tag from 'components/Tag';
import {TechStacks} from 'conf/enums';
import {TechStackStyles} from 'conf/techStackColors';

export const techStackColumns = [
  {
    id: 'language',
    Header: 'Language',
    accessor: (originalRow) => {
      const {techStacks} = originalRow;
      const languages = filter(techStacks, (techStack) => techStack.category === 'LANGUAGE');
      return map(languages, (l) => l.techStackName);
    },
    Cell: renderTechStackCell,
    Filter: LanguageFilter,
    filter: multiselectOrFilter,
    sortable: true,
  },
  {
    id: 'frontend',
    Header: 'Frontend',
    accessor: (originalRow) => {
      const {techStacks} = originalRow;
      const frontend = filter(techStacks, (techStack) => techStack.category === 'FRONTEND');
      return map(frontend, (fe) => fe.techStackName);
    },
    Cell: renderTechStackCell,
    Filter: FrontendFilter,
    filter: multiselectOrFilter,
    sortable: true,
  },
  {
    id: 'backend',
    Header: 'Backend',
    accessor: (originalRow) => {
      const {techStacks} = originalRow;
      const backend = filter(techStacks, (techStack) => techStack.category === 'BACKEND');
      return map(backend, (be) => be.techStackName);
    },
    Cell: renderTechStackCell,
    Filter: BackendFilter,
    filter: multiselectOrFilter,
    sortable: true,
  },
  {
    id: 'database',
    Header: 'Database',
    accessor: (originalRow) => {
      const {techStacks} = originalRow;
      const database = filter(techStacks, (techStack) => techStack.category === 'DATABASE');
      return map(database, (db) => db.techStackName);
    },
    Cell: renderTechStackCell,
    Filter: DatabaseFilter,
    filter: multiselectOrFilter,
    sortable: true,
  },
  {
    id: 'devOps',
    Header: 'Devops',
    accessor: (originalRow) => {
      const {techStacks} = originalRow;
      const devops = filter(techStacks, (techStack) => techStack.category === 'DEVOPS');
      return map(devops, (d) => d.techStackName);
    },
    Cell: renderTechStackCell,
    Filter: DevOpsFilter,
    filter: multiselectOrFilter,
    sortable: true,
  },
  {
    id: 'ai',
    Header: 'AI',
    accessor: (originalRow) => {
      const {techStacks} = originalRow;
      const artificialIntelligence = filter(techStacks, (techStack) => techStack.category === 'AI');
      return map(artificialIntelligence, (ai) => ai.techStackName);
    },
    Cell: renderTechStackCell,
    Filter: AIFilter,
    filter: multiselectOrFilter,
    sortable: true,
  },
];

export const companyTechStackColumns = [
  {
    id: 'firstName',
    Header: 'First Name',
    accessor: 'firstName',
    Filter: TextFilter,
    sortable: true,
    ...flexColumnStyle({width: 200}),
  },
  {
    id: 'lastName',
    Header: 'Last Name',
    accessor: 'lastName',
    Filter: TextFilter,
    sortable: true,
    ...flexColumnStyle({width: 200}),
  },
  ...techStackColumns,
];

export default function UsersTechStackList({data}) {
  return (
    <VirtualizedTable
      data={data}
      columns={companyTechStackColumns}
    />
  );
}

function renderTechStackCell({value}) {
  return (
    <div className="tagContainer">
      {map(value, (val) => (<Tag key={val} style={TechStackStyles[val]} className="tag--sm">{val}</Tag>))}
    </div>
  );
  
}

export function LanguageFilter(props) {
  return <MultiSelectFilter {...props} options={TechStacks.language} />;
}
export function FrontendFilter(props) {
  return <MultiSelectFilter {...props} options={TechStacks.frontend} />;
}
export function BackendFilter(props) {
  return <MultiSelectFilter {...props} options={TechStacks.backend} />;
}
export function DatabaseFilter(props) {
  return <MultiSelectFilter {...props} options={TechStacks.database} />;
}
export function DevOpsFilter(props) {
  return <MultiSelectFilter {...props} options={TechStacks.devOps} />;
}
export function AIFilter(props) {
  return <MultiSelectFilter {...props} options={TechStacks.ai} />;
}
